/**
 * Canonicalls public route + top-rail navigation (stable paths, no runtime state).
 */
import {
  CANONICALLS_PUBLIC_PATHS,
  type CanonicallsPublicPath,
  isCanonicallsPublicPath,
  normalizeCanonicallsPathname,
} from "./canonicallsHost";

export { normalizeCanonicallsPathname, CANONICALLS_PUBLIC_PATHS };
export type { CanonicallsPublicPath };

export type CanonicallsTopNavItem = {
  readonly to: Exclude<CanonicallsPublicPath, "/">;
  readonly label: string;
  readonly cta?: boolean;
};

/** Header rail — home is the brand link to `/`. */
export const CANONICALLS_TOP_NAV: readonly CanonicallsTopNavItem[] = [
  { to: "/canonicalize", label: "Canonicalize", cta: true },
  { to: "/inspect", label: "Inspect" },
  { to: "/replay", label: "Replay" },
  { to: "/aether", label: "Actor" },
] as const;

export const CANONICALLS_HOME_PATH = "/" as const satisfies CanonicallsPublicPath;

export function navAriaCurrent(pathname: string, to: string): "page" | undefined {
  return normalizeCanonicallsPathname(pathname) === normalizeCanonicallsPathname(to)
    ? "page"
    : undefined;
}

export function isCanonicallsTopNavTarget(pathname: string): boolean {
  const p = normalizeCanonicallsPathname(pathname);
  return CANONICALLS_TOP_NAV.some((item) => item.to === p);
}

export function topNavItemForPath(pathname: string): CanonicallsTopNavItem | undefined {
  const p = normalizeCanonicallsPathname(pathname);
  return CANONICALLS_TOP_NAV.find((item) => item.to === p);
}

/** Product surfaces reachable without leaving the public spine. */
export function isCanonicallsProductRoute(pathname: string): boolean {
  return isCanonicallsPublicPath(pathname);
}
